var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCurrentTheme } from '../../hooks/useCurrentTheme';
import { getContrastColor } from '../../helpers/helpers';
import styles from '../Viewer.module.scss';
export function PositionLabel(_a) {
    var player = _a.player, children = _a.children, isPadding = _a.isPadding, _b = _a.style, style = _b === void 0 ? {} : _b, _c = _a.onClick, onClick = _c === void 0 ? null : _c;
    var settings = useCurrentTheme();
    var positionColor = settings.positions[player];
    var textColor = getContrastColor(positionColor);
    return (
    // @ts-ignore
    _jsxs("div", __assign({ className: styles.posLabel, onClick: onClick }, { children: [_jsx("span", __assign({ style: __assign({ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: positionColor, color: textColor, width: isPadding ? '2.5rem' : 46, padding: isPadding ? 3 : '', opacity: isPadding ? 0.9 : '', borderRadius: 2, lineHeight: '24px', fontSize: '0.9rem' }, style) }, { children: player })), children] })));
}
